module.exports = __webpack_public_path__ + "static/img/15.ee82b89.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/12/eng/15.png
// module id = JZX7
// module chunks = 0